import React from 'react';
export default function EmergencyBanners(props) {
    var alerts = props.alerts, setAlerts = props.setAlerts, closeAlert = props.closeAlert, setCloseAlert = props.setCloseAlert;
    var removeAlert = function (idAlert) {
        var newArr = alerts;
        newArr.forEach(function (alert) {
            if (alert.id == idAlert) {
                alert.fields.isVisible = false;
            }
        });
        var removedAlerts = sessionStorage.getItem('removedAlerts');
        var parsedAlerts = removedAlerts ? JSON.parse(removedAlerts) : [];
        var newArrStorage = parsedAlerts.concat([idAlert]);
        sessionStorage.setItem('removedAlerts', JSON.stringify(newArrStorage));
        setAlerts(newArr);
        setCloseAlert(!closeAlert);
        //sessionStorage.setItem('alerts', JSON.stringify(newArr));
    };
    return (alerts.map(function (alert, i) {
        return (React.createElement(React.Fragment, { key: alert.id }, alert.fields.isVisible &&
            React.createElement("div", { className: "alert-item"
                    + ((alert.fields.background) ? (" bg-" + alert.fields.background) : "")
                    + ((alert.fields.textColour) ? (" text-color-" + alert.fields.textColour) : "") },
                React.createElement("div", { className: "container-fluid " },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col" },
                            React.createElement("div", { className: "alert-content position-relative py-2" },
                                React.createElement("div", { className: "me-5 d-flex flex-wrap" },
                                    alert.fields.displayTitle &&
                                        React.createElement("div", { className: "alert-title", dangerouslySetInnerHTML: { __html: alert.fields.displayTitle } }),
                                    alert.fields.staLeftColumn &&
                                        React.createElement("div", { className: "alert-description", dangerouslySetInnerHTML: { __html: alert.fields.staLeftColumn } })),
                                React.createElement("button", { type: "submit", value: "Submit", "aria-label": "Close", className: "close-alert position-absolute end-0 top-0 my-2", onClick: function () { return removeAlert(alert.id); } },
                                    React.createElement("i", { className: "fa-solid fa-close" })))))))));
    }));
}
